<template>
  <v-container
    fill
    fluid
    grid-list-xl>
    <v-form
      ref="auto"
      v-model="isAutoValidationOk"
      lazy-validation>
      <v-container
        v-if="probeCapability !== 3"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            v-if="probeCapability===0"
            xs2
            md1>
            <v-switch
              v-model="probeCustomTLT"
              data-testId="switch"
              class="dover-input text-xs-center"
              @change="onChangeCustomTLT()" />
          </v-flex>
          <v-flex
            v-if="probeCapability===0"
            xs4
            md3
            style="padding-top: 20px;">
            <v-img
              data-testId="img"
              src="./img/tank/leak_detection.png"
              contain
              max-width="300"/>
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-text-field
              v-if="tankWithEPAProbe != undefined && !tankWithEPAProbe"
              v-model.number="customTankLeakRate"
              :counter="6"
              :rules="rules.leak"
              :label="`${ $t('Leak threshold') + ' (' + options.volumeUnits[systemSettings.volumeUnit || 0].desc + '/' + $t('H').toLowerCase() + ')' }`"
              data-testId="text-field-Leak-threshold"
              class="dover-input"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout wrap>
          <v-flex xs12>
            <span>
              {{ $t('Automatic leak test') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-select
              v-model="leakTestType"
              :items="leakTestTypes"
              :label="`${$t('Leak Test Type')}`"
              data-testId="select-Leak-Test-Type"
              item-text="desc"
              item-value="code"
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :key="data.item.code"
                  data-testId="chip"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
                  {{ data.item.desc }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs6
            md3
            lg3><br>
            {{ getLeakTestThreshold() }}
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-if="leakTypeControl === 1"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            align-self-center
            xs6
            md6
            lg6>
            <v-btn-toggle
              v-model="tank.autoLeakTestRepetition"
              data-testId="btn-toggle"
              mandatory
              @change="onTestModeChange()">
              <v-btn
                v-for="(item) in testModes"
                :key="item.index"
                :value="item.value"
                data-testId="btn-item-desc"
                text
                small
                color="dover-blue">
                {{ item.desc }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs6
            md6
            lg6 />
          <v-flex
            xs6
            md3
            lg3>
            <v-switch
              v-if="testModeControl === 0"
              v-model.number="autoLeakTestWarningPeriod"
              :label="`${ $t('NO TEST Warning') }`"
              data-testId="switch-NO-TEST-Warning"
              class="dover-input"
              @change="onAutoLeakTestWarningPeriodChanged()" />
            <v-text-field
              v-else-if="testModeControl === 1"
              v-model.number="autoLeakTestWarningPeriod"
              :counter="1"
              :rules="rules.weekLimit"
              :label="`${ $t('Leak test warning period (in days)') }`"
              data-testId="text-field-Leak-test-warning-period"
              class="dover-input"
              @change="onAutoLeakTestWarningPeriodChanged()" />
            <v-text-field
              v-else-if="testModeControl === 2"
              v-model.number="autoLeakTestWarningPeriod"
              :counter="2"
              :rules="rules.monthLimit"
              :label="`${ $t('Leak test warning period (in days)') }`"
              data-testId="text-field-Leak-test-warning-period-2"
              class="dover-input"
              @change="onAutoLeakTestWarningPeriodChanged()" />
            <v-text-field
              v-else
              v-model.number="autoLeakTestWarningPeriod"
              :counter="3"
              :rules="rules.yearLimit"
              :label="`${ $t('Leak test warning period (in days)') }`"
              data-testId="text-field-Leak-test-warning-period-3"
              class="dover-input"
              @change="onAutoLeakTestWarningPeriodChanged()" />
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-text-field
              v-model.number="tank.autoLeakTestDuration"
              :counter="3"
              :rules="rules.duration"
              :label="`${ $t('Duration (min)') }`"
              data-testId="text-field-Duration"
              mask="###"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-text-field
              v-model.number="tank.autoLeakTestVolumePercent"
              :counter="2"
              :rules="rules.perc"
              :label="`${ $t('Minimum fill (%)') }`"
              data-testId="text-field-Minimum-fill"
              mask="##"
              class="dover-input"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-else-if="leakTypeControl === 2"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            align-self-center
            xs6
            md6
            lg6>
            <v-btn-toggle
              v-model="tank.sldLeakTestRepetition"
              data-testId="btn-toggle-2"
              mandatory
              @change="onSldTestModeChange()">
              <v-btn
                v-for="(item) in sldTestModes"
                :key="item.index"
                :value="item.value"
                data-testId="btn-item-desc-2"
                text
                small
                color="dover-blue">
                {{ item.desc }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs6
            md6
            lg6 />
          <v-flex
            xs6
            md3
            lg3>
            <v-switch
              v-if="sldTestModeControl === 0"
              v-model.number="sldLeakTestWarningPeriod"
              :label="`${$t('NO TEST Warning')}`"
              data-testId="switch-NO-TEST-Warning-2"
              class="dover-input"
              @change="onSldLeakTestWarningPeriodChanged()" />
            <v-text-field
              v-else-if="sldTestModeControl === 1"
              v-model.number="sldLeakTestWarningPeriod"
              :counter="1"
              :rules="rules.weekLimit"
              :label="`${$t('Leak test warning period (in days)')}`"
              data-testId="text-field-Leak-test-warning-period-4"
              class="dover-input"
              @change="onSldLeakTestWarningPeriodChanged()" />
            <v-text-field
              v-else-if="sldTestModeControl === 2"
              v-model.number="sldLeakTestWarningPeriod"
              :counter="2"
              :rules="rules.monthLimit"
              :label="`${$t('Leak test warning period (in days)')}`"
              data-testId="text-field-Leak-test-warning-period-5"
              class="dover-input"
              @change="onSldLeakTestWarningPeriodChanged()" />
            <v-text-field
              v-else
              v-model.number="sldLeakTestWarningPeriod"
              :counter="3"
              :rules="rules.yearLimit"
              :label="`${$t('Leak test warning period (in days)')}`"
              data-testId="text-field-Leak-test-warning-period-6"
              class="dover-input"
              @change="onSldLeakTestWarningPeriodChanged()" />
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-switch
              v-model="tank.largeTankMode"
              :label="`${$t('Extend data collection')}`"
              :disabled="tank.tankGroup !== 0"
              data-testId="switch-Extend-data-collection"
              class="dover-input text-xs-center" />
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-switch
              v-model="tank.highThroughputMode"
              :label="`${$t('High Activity Mode')}`"
              data-testId="switch-High-Activity-Mode"
              class="dover-input text-xs-center" />
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <v-switch
              v-if="leakTypeControl === 2"
              v-model="sldRetestLimit"
              :label="`${$t('Auto Re-test Confirmation')}`"
              data-testId="switch-Auto-Re-test-Confirmation"
              true-value="1"
              false-value="0"
              class="dover-input text-xs-center" />
          </v-flex>

          <v-flex
            v-if="tank.tankGroup !== 0"
            xs6
            md3
            lg3>
            <v-select
              v-model="tank.manifoldType"
              :items="manifoldTypes"
              :label="`${$t('Manifold Type')}`"
              :disabled="true"
              data-testId="select-Manifold-Type"
              item-text="desc"
              item-value="code"
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :key="data.item.code"
                  data-testId="chip-2"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
                  {{ data.item.desc }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            v-if="tank.tankGroup !== 0"
            xs6
            md3
            lg3>
            <v-text-field
              v-model.number="manifoldOffset"
              :counter="6"
              :rules="rules.offset"
              :disabled="tank.tankGroup === 0"
              :label="`${$t('Manifold Offset') + ' (' + options.levelUnits[systemSettings.levelUnit || 0].desc + ')'}`"
              data-testId="text-field-Manifold-Offset"
              class="dover-input" />
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-else
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap
          row />
      </v-container>
      <v-flex
        xs12
        md12
        lg12
        text-xs-right>
        <v-btn
          data-testId="btn-Save"
          small
          class="mx-0 font-weight-light"
          color="dover-blue"
          @click="saveTankSettings">
          {{ $t('Save') }}
        </v-btn>
      </v-flex>
    </v-form>
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-layout
        row
        wrap>
        <template>
          <v-flex
            xs12>
            <span>
              {{ $t('Scheduled leak test') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md4
            lg4>
            <MaglinkComponentDateTimePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :rules="rules.required.concat(rules.time)"
              :initial-date="scheduledDate"
              :date-format="systemSettings.dateFormat"
              :time-format="timeFormat"
              :date-label="getDateLabel('Date')"
              :min-date="dateFromToday(0)"
              :max-date="dateFromToday(365)"
              :clear-date="false"
              :loading="false"
              data-testId="MaglinkComponentDateTimePicker"
              @getDate="onGetDate"/>
          </v-flex>
          <v-flex
            v-show="isConfigured"
            xs12
            md4
            lg4>
            <v-text-field
              v-if="tankWithEPAProbe != undefined && !tankWithEPAProbe"
              v-model.number="customTankLeakRate"
              :disabled="true"
              :label="`${$t('Leak threshold') + ' (' + options.volumeUnits[systemSettings.volumeUnit || 0].desc + '/' + $t('H').toLowerCase() + ')'}`"
              data-testId="text-field-Leak-threshold"
              class="dover-input"/>
            <v-radio-group
              v-else
              v-model.number="testLeakageType"
              :row="true"
              data-testId="radio-group">
              <v-radio
                v-for="(element, index) in leakThresholds"
                :key="index"
                :label="`${ leakLabel(element.real) }`"
                :value="element.code"
                data-testId="radio-leakLabel-element-real"/>
            </v-radio-group>
          </v-flex>
          <v-flex
            v-show="isConfigured"
            xs6
            md2
            lg2>
            <v-text-field
              v-model.number="scheduledLeakTest.duration"
              :counter="3"
              :rules="rules.required.concat(rules.duration)"
              :label="`${ $t('Duration (min)') }`"
              data-testId="text-field-Duration-2"
              mask="###"
              class="dover-input"/>
          </v-flex>
          <v-flex
            v-show="isConfigured"
            xs6
            md2
            lg2>
            <v-text-field
              v-model.number="scheduledLeakTest.volumePercent"
              :counter="2"
              :rules="rules.required.concat(rules.perc)"
              :label="`${ $t('Minimum fill (%)') }`"
              data-testId="text-field-Minimum-fill-2"
              mask="##"
              class="dover-input"/>
          </v-flex>
          <v-flex
            v-show="!isConfigured"
            xs12>
            <span data-testId="span-No-leak-test-scheduled">
              {{ $t('No leak test scheduled') }}
            </span>
          </v-flex>
        </template>
      </v-layout>
      <v-layout
        row
        wrap>
        <v-flex
          xs12
          md12
          text-xs-right>
          <v-btn
            data-testId="btn-Save-2"
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="saveScheduledLeakTest">
            {{ $t('Save') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    probeDetected: {
      type: Array,
      required: true,
      default: () => []
    },
    scheduledLeakTest: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    sldRetestLimit: '0',
    tankWithEPAProbe: false,
    probeCustomTLT: false,
    probeCapability: undefined,
    isValidationOk: true,
    isAutoValidationOk: true,
    rules: {
      required: [v => Vue.prototype.Maglink.RulesRequired(v)],
      perc: [v => Vue.prototype.Maglink.RulesRange(v, 0, 99)],
      duration: [v => Vue.prototype.Maglink.RulesRange(v, 30, 900)],
      time: [v => Vue.prototype.Maglink.MinDate(v, new Date())],
      isDate: [v => true],
      weekLimit: [v => Vue.prototype.Maglink.RulesRange(v, 0, 7)],
      monthLimit: [v => Vue.prototype.Maglink.RulesRange(v, 0, 30)],
      yearLimit: [v => Vue.prototype.Maglink.RulesRange(v, 0, 365)],
      leak: [v => Vue.prototype.Maglink.RulesRange(v, 1.0, 1321)],
      offset: [v => Vue.prototype.Maglink.RulesRange(v, -1000.0, 1000.0)]
    },
    isConfigured: false,
    leakThresholds: [],
    timeFormat: 'hh:mm',
    testModeControl: 3,
    testModes: [
      { index: 0, value: 1440, desc: i18n.t('Daily'), limit: 0 },
      { index: 1, value: 10080, desc: i18n.t('Weekly'), limit: 7 },
      { index: 2, value: 43200, desc: i18n.t('Monthly'), limit: 30 },
      { index: 3, value: 525600, desc: i18n.t('Yearly'), limit: 365 }
    ],
    warningPeriod: {
      isDaily: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: true
    },
    leakTestTypes: [],
    leakTypeControl: 0,
    manifoldTypes: [
      { code: 0, desc: i18n.t('Not Defined') },
      { code: 1, desc: i18n.t('Siphon') },
      { code: 2, desc: i18n.t('Balance Pipe') },
      { code: 3, desc: i18n.t('Suction Valve') },
      { code: 4, desc: i18n.t('Gated Valve') }
    ],
    sldTestModeControl: 3,
    sldTestModes: [
      { index: 0, value: 1440, desc: i18n.t('Daily'), limit: 0 },
      { index: 1, value: 10080, desc: i18n.t('Weekly'), limit: 7 },
      { index: 2, value: 43200, desc: i18n.t('Monthly'), limit: 30 },
      { index: 3, value: 525600, desc: i18n.t('Yearly'), limit: 365 }
    ],
    sldWarningPeriod: {
      isDaily: false,
      isWeekly: false,
      isMonthly: false,
      isYearly: true
    },
    capability: 0,
    autoLeakTestWarningPeriod: 0,
    sldLeakTestWarningPeriod: 0,
    dataReloadOnError: 0
  }),
  computed: {
    testLeakageType: {
      get () {
        return this.scheduledLeakTest.leakageType - 1
      },
      set (value) {
        this.scheduledLeakTest.leakageType = value + 1
      }
    },
    customTankLeakRate: {
      get () {
        return this.Maglink.LeakageToDisplay(this.tank.customTankLeakRate, this.systemSettings.volumeUnit || 0)
      },
      set (value) {
        this.tank.customTankLeakRate = this.Maglink.LeakageFromDisplay(value, this.systemSettings.volumeUnit || 0)
      }
    },
    manifoldOffset: {
      get () {
        return this.Maglink.LevelToDisplay(this.tank.manifoldOffset, this.systemSettings.levelUnit || 0)
      },
      set (value) {
        this.tank.manifoldOffset = this.Maglink.LevelFromDisplay(value, this.systemSettings.levelUnit || 0)
      }
    },
    leakTestType: {
      get () {
        return this.tank.autoLeakTestType
      },
      set (value) {
        this.tank.autoLeakTestType = value
        this.leakTypeControl = value
      }
    },
    scheduledDate () {
      if (this.scheduledLeakTest.time > 0) {
        return new Date(this.scheduledLeakTest.time * 1000)
      }
      return false
    }
  },
  watch: {
    tank: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        this.sldRetestLimit = `${newVal.sldRetestLimit}`
        var valueNew = true
        if (oldVal !== undefined) {
          valueNew = oldVal.autoLeakTestType === newVal.autoLeakTestType &&
            ((newVal.autoLeakTestType === 1 && oldVal.autoLeakTestRepetition === newVal.autoLeakTestRepetition) ||
              (newVal.autoLeakTestType === 2 && oldVal.sldLeakTestRepetition === newVal.sldLeakTestRepetition))
        }

        if (valueNew) {
          this.leakTypeControl = newVal.autoLeakTestType
          if (newVal.autoLeakTestRepetition === 0) newVal.autoLeakTestRepetition = this.testModes[3].value
          if (newVal.sldLeakTestRepetition === 0) newVal.sldLeakTestRepetition = this.sldTestModes[3].value

          if (newVal.autoLeakTestType === 1) {
            if (newVal.autoLeakTestRepetition === this.testModes[0].value) {
              this.testModeControl = 0
            } else if (newVal.autoLeakTestRepetition === this.testModes[1].value) {
              this.testModeControl = 1
            } else if (newVal.autoLeakTestRepetition === this.testModes[2].value) {
              this.testModeControl = 2
            } else {
              this.testModeControl = 3
            }
            this.autoLeakTestWarningPeriod = newVal.autoLeakTestWarningPeriod / 1440
          } else if (newVal.autoLeakTestType === 2) {
            if (newVal.sldLeakTestRepetition === this.sldTestModes[0].value) {
              this.sldTestModeControl = 0
            } else if (newVal.sldLeakTestRepetition === this.sldTestModes[1].value) {
              this.sldTestModeControl = 1
            } else if (newVal.sldLeakTestRepetition === this.sldTestModes[2].value) {
              this.sldTestModeControl = 2
            } else {
              this.sldTestModeControl = 3
            }
            this.sldLeakTestWarningPeriod = newVal.sldLeakTestWarningPeriod / 1440
          }
        }

        if (newVal.maxVolume > 49210) newVal.largeTankMode = true
        this.rules.offset = [v => Vue.prototype.Maglink.RulesRange(v, -newVal.maxLevel, newVal.maxLevel)]

        this.fillLeakTypes()
      }
    },
    probeDetected: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        if (newVal !== undefined) {
          for (var i = 0; i < newVal.length; i++) {
            if (newVal[i].serial * 1 === this.tank.serial * 1) {
              this.capability = newVal[i].capability

              /*
              if (!this.Maglink.isEPAProbeExtended(this.tank.probeType, this.capability) && this.Maglink.isDMPProbe(this.tank.probeType)) {
                if (this.systemSettings.volumeUnit === 1) {
                  this.rules.leak = [v => Vue.prototype.Maglink.RulesRange(v, 0.1, 99.9)]
                } else {
                  this.rules.leak = [v => Vue.prototype.Maglink.RulesRange(v, 0.379, 99.9)]
                }
              }
              this.fillLeakTypes()
              */
            }
          }
        }
      }
    },
    $totalCsldTanks: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        this.fillLeakTypes()
      }
    }
  },
  mounted () {
    this.leakThresholds = this.options.leakThresholds
    // remove 3.0 check
    this.leakThresholds.length = 2
    if (this.scheduledLeakTest.time > 0) {
      this.isConfigured = true
    }

    this.rules.leak = [ v => {
      let v2 = v * 1.0 // parseFloat(v.replaceAll(',', '.'))
      return Vue.prototype.Maglink.RulesRange(v2, this.calculateMinimumLeak(), this.calculateMaximumLeak())
    }]
    this.requestTankData()
  },
  methods: {
    fillLeakTypes () {
      this.leakTestTypes = []

      this.leakTestTypes.push({ code: 0, desc: i18n.t('Disabled') })
      this.leakTestTypes.push({ code: 1, desc: i18n.t('Static') })
      if (this.$totalCsldTanks > -1 && this.tank !== undefined) {
        if (this.tank.autoLeakTestType === 2 || this.$totalCsldTanks < 6) {
          if (this.tankWithEPAProbe !== undefined && this.tankWithEPAProbe && this.leakTestTypes.length === 2 && Vue.prototype.Maglink.hasCsld) this.leakTestTypes.push({ code: 2, desc: i18n.t('CSLD') })
        }
      }
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)
      return currentDate
    },
    onGetDate (componentKey, date) {
      if (!date) {
        this.isConfigured = false
        this.scheduledLeakTest.time = 0
      } else {
        this.isConfigured = true
        this.scheduledLeakTest.time = date.getTime() / 1000
      }
      this.checkDate()
    },
    requestTankData () {
      this.Maglink.GetTankStatus(this.tank.tankNumber)
        .then(response => {
          if (response.data.tankWithEPAProbe === response.data.probeCustomTLT) {
            if (this.dataReloadOnError === 5) {
              // Error
              return
            }
            setTimeout(this.requestTankData, 3000)
            this.dataReloadOnError++
          } else {
            this.tankWithEPAProbe = response.data.tankWithEPAProbe
            this.probeCustomTLT = !response.data.probeCustomTLT
            this.probeCapability = response.data.probeCapability
            this.fillLeakTypes()
            this.dataReloadOnError = 0
          }
        })
    },
    getDateLabel (value) {
      return this.$t(value)
    },
    checkDate () {
      if (this.scheduledLeakTest.time === 0) {
        this.rules.isDate = [ v => true ]
        return true
      }

      var dt = new Date((this.scheduledLeakTest.time + 180) * 1000) // 3 minutes back
      if (dt < new Date()) {
        this.rules.isDate = [this.$t('Wrong date value')]
        return false
      }
      this.rules.isDate = [ v => true ]
      return true
    },
    saveScheduledLeakTest (event) {
      if (!this.checkDate()) {
        return
      }
      if (this.$refs.form.validate()) {
        this.isValidationOk = true
        if (this.isConfigured) {
          this.$emit('scheduledLeakTestSaved', this.tank.tankNumber)
        } else {
          this.$emit('scheduledLeakTestDeleted', this.tank.tankNumber)
        }
      } else {
        this.isValidationOk = false
      }
    },
    saveTankSettings (event) {
      if (this.$refs.auto.validate()) {
        this.tank.sldRetestLimit = this.sldRetestLimit === '0' ? 0 : 1
        this.isAutoValidationOk = true
        this.$emit('tankSaved', this.tank.tankNumber)
      } else {
        this.isAutoValidationOk = false
      }
    },
    onSldTestModeChange () {
      this.tank.autoLeakTestDuration = 120
      this.tank.autoLeakTestVolumePercent = 50
      this.tank.customTankLeakRate = 1.0

      switch (this.tank.sldLeakTestRepetition) {
        case this.sldTestModes[0].value:
          this.sldWarningPeriod.isDaily = true
          this.sldWarningPeriod.isWeekly = false
          this.sldWarningPeriod.isMonthly = false
          this.sldWarningPeriod.isYearly = false
          this.sldTestModeControl = 0
          break

        case this.sldTestModes[1].value:
          this.sldWarningPeriod.isDaily = false
          this.sldWarningPeriod.isWeekly = true
          this.sldWarningPeriod.isMonthly = false
          this.sldWarningPeriod.isYearly = false
          this.sldTestModeControl = 1
          break

        case this.sldTestModes[2].value:
          this.sldWarningPeriod.isDaily = false
          this.sldWarningPeriod.isWeekly = false
          this.sldWarningPeriod.isMonthly = true
          this.sldWarningPeriod.isYearly = false
          this.sldTestModeControl = 2
          break

        default:
          this.sldWarningPeriod.isDaily = false
          this.sldWarningPeriod.isWeekly = false
          this.sldWarningPeriod.isMonthly = false
          this.sldWarningPeriod.isYearly = true
          this.sldTestModeControl = 3
          break
      }

      this.sldLeakTestWarningPeriod = 0
      this.onSldLeakTestWarningPeriodChanged()
    },
    onTestModeChange () {
      this.tank.autoLeakTestDuration = 120
      this.tank.autoLeakTestVolumePercent = 50
      this.tank.customTankLeakRate = 1.0

      switch (this.tank.autoLeakTestRepetition) {
        case this.testModes[0].value:
          this.warningPeriod.isDaily = true
          this.warningPeriod.isWeekly = false
          this.warningPeriod.isMonthly = false
          this.warningPeriod.isYearly = false
          this.testModeControl = 0
          break

        case this.testModes[1].value:
          this.warningPeriod.isDaily = false
          this.warningPeriod.isWeekly = true
          this.warningPeriod.isMonthly = false
          this.warningPeriod.isYearly = false
          this.testModeControl = 1
          break

        case this.testModes[2].value:
          this.warningPeriod.isDaily = false
          this.warningPeriod.isWeekly = false
          this.warningPeriod.isMonthly = true
          this.warningPeriod.isYearly = false
          this.testModeControl = 2
          break

        default:
          this.warningPeriod.isDaily = false
          this.warningPeriod.isWeekly = false
          this.warningPeriod.isMonthly = false
          this.warningPeriod.isYearly = true
          this.testModeControl = 3
          break
      }

      this.autoLeakTestWarningPeriod = 0
      this.onAutoLeakTestWarningPeriodChanged()
    },

    onAutoLeakTestWarningPeriodChanged () {
      if (this.warningPeriod.isDaily) {
        if (this.autoLeakTestWarningPeriod === 0) {
          this.tank.autoLeakTestWarningPeriod = 0
        } else {
          this.tank.autoLeakTestWarningPeriod = 1440
        }
      } else {
        this.tank.autoLeakTestWarningPeriod = this.autoLeakTestWarningPeriod * 1440
      }
    },
    onSldLeakTestWarningPeriodChanged () {
      if (this.sldWarningPeriod.isDaily) {
        if (this.sldLeakTestWarningPeriod === 0) {
          this.tank.sldLeakTestWarningPeriod = 0
        } else {
          this.tank.sldLeakTestWarningPeriod = 1440
        }
      } else {
        this.tank.sldLeakTestWarningPeriod = this.sldLeakTestWarningPeriod * 1440
      }
    },
    leakLabel (leakValue) {
      var label = '' + this.Maglink.LeakageToDisplay(leakValue * 1.0, this.systemSettings.volumeUnit)
      label += ' ' + this.Maglink.LeakShortUdm(this.systemSettings.volumeUnit || 0)
      return label
    },
    leakLabelFromGph (leakValue) {
      return this.leakLabel(leakValue * 3.78541)
    },
    getLeakTestThreshold () {
      if (this.tank.autoLeakTestType === 0) {
        return ''
      }
      if (this.tankWithEPAProbe || this.tank.autoLeakTestType === 2) {
        return this.leakLabelFromGph(0.2)
      }

      return this.leakLabel(this.tank.customTankLeakRate)
    },
    calculateMaximumLeak () {
      return (this.systemSettings.volumeUnit || 0) === 0 ? 5000.0 : 1321.0
    },
    calculateMinimumLeak () {
      let gasoline = (this.isGasoline(this.tank.productFamily) ? 1.0 : 0.5)

      let minThreshold = (this.tank.maxVolume * gasoline * 3.785) / 13000

      if ((this.systemSettings.volumeUnit || 0) === 1) {
        if (minThreshold < 1.0) {
          minThreshold = 1.0
        }
      } else {
        if (minThreshold < 3.785) {
          minThreshold = 3.785
        }
      }
      return minThreshold.toFixed(3)
    },
    isGasoline (product) {
      let found = this.Maglink.Products.find(r => r.code === product) || -1
      if (found !== -1) {
        return found.baseDensity <= 780
      }

      return product >= 7 && product <= 16
    },
    isDMPProbe (probeType) {
      if (probeType === 1 || probeType === 15 || probeType === 16) {
        return true
      } else if (probeType === 2 || probeType === 3 || probeType === 4) { // obsolete
        return true
      } else {
        return false
      }
    },
    isDMPOWProbe (probeType) {
      if (probeType === 10 || probeType === 18 || probeType === 12) {
        return true
      }

      return false
    },
    isPGProbe (probeType) {
      if (probeType === 1 || probeType === 5 || probeType === 8 || probeType === 15 || probeType === 16 || probeType === 17) { // current
        return true
      } else if (probeType === 2 || probeType === 3 || probeType === 4 || probeType === 6 || probeType === 7) { // obsolete
        return true
      } else {
        return false
      }
    },
    convertProbeType (probeType) {
      switch (probeType) {
        case 0: return 5 // TPT_XMT_XSI;
        case 2: return 8 // TPT_XSI_RF;
        case 4: return 5 // TPT_XMT_XSI; // TPT_XMT_XSI_AEF;
        case 5: return 8 // TPT_XSI_RF; // TPT_XMT_XSI_AEF_RF;
        case 6: return 1 // TPT_DMP;
        case 7: return 1 // TPT_DMP; // TPT_DMP_DENS;
        case 8: return 1 // TPT_DMP;  // TPT_DMP_AEF;
        case 9: return 1 // TPT_DMP; // ??
        case 10: return 1 // TPT_DMP; // TPT_DMP_AEF;
        case 11: return 1 // TPT_DMP; // TPT_DMP_DENS_AEF;
        case 12: return 9 // TPT_PV_924B
        case 13: return 10 // TPT_DMP_ONE_WIRE
        case 14: return 11 // TPT_PN_ANALOG
        case 15: return 10 // TPT_DMP_ONE_WIRE
        case 16: return 14 // TPT_RADAR
        case 17: return 15 // TPT_DMP_FLEX
        case 18: return 13 // TPT_PV_924A
        case 19: return 17 // TPT_XMT_EXD
        case 20: return 18 // TPT_DMP_FLEX_ONE_WIRE
        default: return 0
      }
    },
    isTankWithEPACapability () {
      if ((this.probeCapability & 1) !== 0) {
        return true
      }

      if ((this.probeCapability & 4) !== 0) {
        return false
      }

      if ((this.probeCapability & 7) === 0) {
        let probe = this.convertProbeType(this.tank.probeType)
        if (this.isDMPProbe(probe) || this.isDMPOWProbe(probe)) {
          if (this.tank.probeCustomTLT) {
            return false
          } else {
            return true
          }
        } else if (this.isPGProbe(probe)) { // IsPGProbe
          return false
        }
      }

      return false
    },
    onChangeCustomTLT () {
      this.tank.probeCustomTLT = !this.probeCustomTLT
      this.tankWithEPAProbe = this.isTankWithEPACapability()
      this.fillLeakTypes()
    }

  }
}
</script>
